import {
  TDiscounts,
  TFees,
} from 'modules/accommodations/features/rentals/CreateRental/PriceList/models';

export const transformDataForTable = (dataArray: Array<any>) => {
  return dataArray?.map((item: TDiscounts | TFees, index: number) => {
    return { key: index, data: item };
  });
};
